var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadCloud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    className: "animate-bounce",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.293 512.293",
    style: {
      enableBackground: "new 0 0 512.293 512.293"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M402.148,149.606C384.338,63.054,299.735,7.328,213.183,25.138 C139.07,40.389,85.774,105.472,85.434,181.136c0,3.605,0.149,7.296,0.469,11.2C33.178,197.917-5.04,245.183,0.541,297.908 c5.173,48.87,46.416,85.943,95.559,85.895h11.2c-0.256-3.541-0.533-7.061-0.533-10.667c0-76.583,62.083-138.667,138.667-138.667 S384.1,296.553,384.1,373.136c0,3.605-0.277,7.125-0.533,10.667h11.2c64.73,0.177,117.348-52.154,117.525-116.885 C512.462,204.807,464.148,153.348,402.148,149.606L402.148,149.606z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#1D79F2"
    },
    cx: 245.434,
    cy: 373.136,
    r: 117.333
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M245.434,447.803c-5.891,0-10.667-4.776-10.667-10.667v-128c0-5.891,4.776-10.667,10.667-10.667 s10.667,4.776,10.667,10.667v128C256.1,443.027,251.325,447.803,245.434,447.803z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M288.1,362.47c-2.831,0.005-5.548-1.115-7.552-3.115l-35.115-35.136l-35.115,35.136 c-4.237,4.093-10.99,3.975-15.083-0.262c-3.993-4.134-3.993-10.687,0-14.821l42.667-42.667c4.165-4.164,10.917-4.164,15.083,0 l42.667,42.667c4.159,4.172,4.149,10.926-0.024,15.085C293.63,361.35,290.923,362.469,288.1,362.47z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloud);
export default __webpack_public_path__ + "static/media/upload-cloud.7c81d181e46b686c9c54b231e8ee663b.svg";
export { ForwardRef as ReactComponent };